export enum GlassgowCommaScoreConstants {
  SET_EYE_RESPONSE = 'glassgowCommaScore/SET_EYE_RESPONSE',
  SET_EYE_PNNV = 'glassgowCommaScore/SET_EYE_PNNV',
  SET_EYE_PNNV_ENABLED = 'glassgowCommaScore/SET_EYE_PNNV_ENABLED',
  SET_VERBAL_RESPONSE = 'glassgowCommaScore/SET_VERBAL_RESPONSE',
  SET_VERBAL_PNNV = 'glassgowCommaScore/SET_VERBAL_PNNV',
  SET_VERBAL_PNNV_ENABLED = 'glassgowCommaScore/SET_VERBAL_PNNV_ENABLED',
  SET_MOTOR_RESPONSE = 'glassgowCommaScore/SET_MOTOR_RESPONSE',
  SET_MOTOR_PNNV = 'glassgowCommaScore/SET_MOTOR_PNNV',
  SET_MOTOR_PNNV_ENABLED = 'glassgowCommaScore/SET_MOTOR_PNNV_ENABLED',
  SET_TOTAL_REASON_PNNV = 'glassgowCommaScore/SET_TOTAL_REASON_PNNV',
  SET_TOTAL_PNNV_ENABLED = 'glassgowCommaScore/SET_TOTAL_PNNV_ENABLED',
  SET_GLASSGOW_COMMA_SCORE = 'glassgowCommaScore/SET_GLASSGOW_COMMA_SCORE',
  SET_QUALIFIER = 'glassgowCommaScore/SET_QUALIFIER',
  SET_QUALIFIER_PNNV = 'glassgowCommaScore/SET_QUALIFIER_PNNV',
  SAVE_GLASSGOW_COMMA_SCORE = 'glassgowCommaScore/SAVE_GLASSGOW_COMMA_SCORE',
  RESET_GLASSGOW_COMMA_SCORE = 'glassgowCommaScore/RESET_GLASSGOW_COMMA_SCORE',
  SET_GLASSGOW_COMMA_SCORE_DATA = 'glassgowCommaScore/SET_GLASSGOW_COMMA_SCORE_DATA',
}
